import { render } from "./UpsellCart.vue?vue&type=template&id=0ee5c364&scoped=true"
import script from "./UpsellCart.vue?vue&type=script&lang=js"
export * from "./UpsellCart.vue?vue&type=script&lang=js"

import "./UpsellCart.vue?vue&type=style&index=0&id=0ee5c364&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee5c364"]])

export default __exports__